export function formatCameraDeviceLabel (device, index) {
  const raw = String((device && device.label) || '').trim()
  const lower = raw.toLowerCase()
  const fallback = `摄像头${(index || 0) + 1}`
  if (!lower) {
    return fallback
  }
  if (isFrontLabel(lower)) {
    return '前置摄像头'
  }
  if (/ultra|超广|\buw\b/.test(lower)) {
    return '后置超广角'
  }
  if (/tele|长焦/.test(lower)) {
    return '后置长焦'
  }
  if (/macro|微距/.test(lower)) {
    return '后置微距'
  }
  if (/(wide|广角)/.test(lower) && !/ultra|超广/.test(lower)) {
    return '后置广角'
  }
  if (/camera2?\s*0/.test(lower) && isBackLabel(lower)) {
    return '后置主摄'
  }
  if (isBackLabel(lower)) {
    const cameraIndex = readCameraIndex(lower)
    return cameraIndex != null ? `后置摄像头${cameraIndex}` : '后置摄像头'
  }
  return fallback
}

function isFrontLabel (label) {
  return /front|user|前/.test(label) && !/back|rear|后|背/.test(label)
}

function isBackLabel (label) {
  return /back|rear|environment|后|背/.test(label)
}

function readCameraIndex (label) {
  const matched = String(label || '').match(/camera2?\s*(\d+)/i)
  if (!matched) {
    return null
  }
  return Number(matched[1])
}
